// extracted by mini-css-extract-plugin
export default {"Zone":"ZoneWindow_Zone__voDDe"};